import { UIView, useCurrentStateAndParams } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";

import { useLLMTrackerCampaignsPrefetch } from "./llm-tracker-service/useLLMTrackerCampaigns";

export const LLMParentContainer = () => {
    const { state, params } = useCurrentStateAndParams();
    useLLMTrackerCampaignsPrefetch();

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            resetKeys={[state, params]}
        >
            <UIView />
        </ErrorBoundary>
    );
};
